import React from 'react'
import {Box} from 'grommet'
import AccountForm from '../../components/accountForm'
import { API,Auth } from 'aws-amplify';
import { NavigationSnackBar,ReturnAddress } from '../../components/utils/shared/shared';
import {withRouter} from 'react-router-dom'


class CreateCustomer extends React.Component {

    state = {
        load: false,
        value: { name: '', primary_contact_person: '',primary_contact_email: '', primary_contact_phone: '',address:{AddressLineOne: '', AddressLineTwo: '',AddressLineThree: '',City: '',PostCode: '',Country: ''}, Country: {CountryCode: ""}, country: {CountryCode: ""}},
        lab: {}
    }
    componentDidMount(){
      Auth.currentSession().then(session => {
        API
        .get("LabShip", "/set_origin_lab",{headers: { 
            Authorization: session.idToken.jwtToken,
          }})
          .then(
            (result) => {
              this.setState({lab: result[0]})
            },
            (error) => {
              console.log(error);
            }
          );  
      })
    }
   
    handleValueChange = (event) => {
        this.setState({value: event});
      };

    handleSubmit = () => {
        this.setState({load: true})
        const customer = ReturnAddress(this.state.value, 'customer', 'create', this.state.lab.id)
        Auth.currentSession().then(session => {
          API
          .post("LabShip", "/customers",
          { headers: { 
            Authorization: session.idToken.jwtToken,
          }, 
          body:{customer: customer}})
          .then(shipment => {
           this.setState({load: false})
           if (this.props.user === 'SuperAdmin'){
            this.props.history.push({pathname: '/admin/customers/all',customerSucc: true, edit:false})
           } else { 
            this.props.history.push({pathname:'/customers/all', customerSucc: true, edit:false})
           }
           
         })
        })
      }
    
    render(){
        const {load,value} = this.state;
        return ( 
          <Box>
            <NavigationSnackBar title='Create Customer' user={this.props.user} pages={[{name: 'Dashboard',link: '/dashboard'},{name: 'Customers', link: '/customers/all'}]}  />
            <Box direction='row' alignSelf='center' elevation='medium' round>
                <AccountForm user={this.props.user} showQuote={this.state.lab.display_quote} label={'Create Customer'} handleSubmit={this.handleSubmit} lab={this.state.lab} setAccount={this.handleValueChange} account={value} load={load} />
              </Box>
            </Box>
          )
    }
}

export default withRouter(CreateCustomer)
